/**
 * st-open-chat.js  (Sportstech, additiv)
 *
 * Integration gegen die offizielle Alhena/Gleen-JS-API (window.gleenWidget).
 * Doku: alhena.gitbook.io/docs/developer-reference/website-sdk
 * Das Widget selbst wird NICHT editiert. App-update-safe.
 * Siehe reference_alhena_chat_widget.
 *
 * AUFGABE 1 — "#open-chat"-Links oeffnen das Chat-Widget
 *   z.B. Buttons/Bilder der multicolumn-Section auf /pages/kundenservice.
 *   Verhalten haengt am Href, nicht am Section-Code -> im Theme-Editor pflegbar.
 *   Primaer gleenWidget.open(), Fallback = nativen Launcher klicken.
 *
 * AUFGABE 2 — Icebreaker-Postback -> Botpress-Chat (ST 2026-07-30)
 *   Der Icebreaker "Wechsel zu einem Support-Spezialisten" ist in Alhena als
 *   type=POSTBACK mit postback_payload="CUSTOMER_SUPPORT" konfiguriert. Alhena
 *   feuert dafuer nur das Event 'icebreaker_question:postback' und erwartet,
 *   dass die Website reagiert — ohne Listener passiert beim Klick NICHTS
 *   (Bug-Report Quang Anh, 2026-07-30 nach Shopify-Golive).
 *   Vorlage: Gleen-AI/sportstech -> bot_press_open_direct_link. Hier gehaertet:
 *
 *   a) GATE auf postback_payload === 'CUSTOMER_SUPPORT'. Das Event feuert laut
 *      Doku auch fuer *jeden Quick-Reply-Button* im laufenden Gespraech —
 *      ungefiltert wuerde also jeder Quick-Reply das Widget schliessen und einen
 *      Botpress-Tab aufreissen. Payload ist in de/en/fr/it/es/nl identisch
 *      (geprueft 2026-07-30 via /icebreaker_questions/get_bot_profile_ice_breaker_questions,
 *      company_key=sportstech-eu), daher eine Konstante fuer alle 7 Maerkte.
 *
 *   b) RETURN-WERT: gleenWidget.handleEventCallbacks() wertet
 *      callbacks.every(cb => cb(data) === true) aus. true = Alhenas
 *      Default-Handling unterdrueckt (Frage geht NICHT an die KI),
 *      false/undefined = Alhena macht normal weiter. Wir geben true nur im
 *      Treffer-Fall zurueck, sonst immer false.
 *
 *   c) close() + hideLauncher() statt Inline-display:none. Inline-Styles wuerden
 *      mit dem klassenbasierten st-alhena-visibility.css kollidieren und waeren
 *      nicht mehr zurueckzunehmen; die API-Variante ist per showLauncher()
 *      reversibel und gilt ohnehin nur fuer den aktuellen Seitenaufruf.
 *
 *   d) window.open() SYNCHRON im Callback (Klick-Gesture-Kontext), ohne
 *      'noopener' in den windowFeatures — mit noopener liefert window.open per
 *      Spec null zurueck, was unseren Popup-Blocker-Fallback faelschlich
 *      ausgeloest und den User im selben Tab weggenavigiert haette.
 *
 *   Debug: URL-Parameter ?stChatDebug=1 loggt jedes Postback-Payload.
 *
 * Rollback: theme_backups/botpress_20260730/ + Loader-Zeile in theme.liquid.
 */
(function () {
  'use strict';

  // Datei wird global (theme.liquid) UND seiten-lokal (page.customer-service.json)
  // geladen -> Doppel-Registrierung verhindern.
  if (window.__stOpenChatInit) return;
  window.__stOpenChatInit = true;

  var SENTINEL = '#open-chat';
  var POSTBACK_EVENT = 'icebreaker_question:postback';
  var POSTBACK_PAYLOAD = 'CUSTOMER_SUPPORT';
  var POSTBACK_URL = 'https://chat.sportstech.link/';
  var MAX_TRIES = 24; // ~6s bei 250ms — nur fuer den Klick-Pfad (Aufgabe 1)
  var INTERVAL = 250;
  // Registrierungs-Fenster (Aufgabe 2) absichtlich LANG: haelt ein Consent-Manager
  // den Alhena-Loader bis zur Cookie-Entscheidung zurueck, existiert
  // window.gleenWidget erst Sekunden bis Minuten nach dem Pageload. Mit einem
  // 6s-Fenster wuerde die Registrierung ablaufen, bevor das SDK da ist — der
  // Button waere wieder tot. Alhenas eigener Loader faengt Cookiebot/OneTrust/
  // CookieYes/Osano ab, aber NICHT Pandectes (= unser CMP), wir koennen uns also
  // auf kein CMP-Event verlassen und pollen stattdessen lange und billig.
  var POLL_FAST_MS = 250;
  var POLL_FAST_UNTIL = 10000;  // erste 10s engmaschig
  var POLL_SLOW_MS = 2000;      // danach alle 2s
  var POLL_GIVE_UP = 120000;    // ~95 Property-Checks in 2min -> messbar 0
  // Der Loader (gleenWidget.js) legt window.gleenWidget synchron an, die
  // React-App (chat-widget/main.js) patcht die Methoden spaeter. Falls sie dabei
  // eventCallbacks neu aufsetzt, verlieren wir unsere Registrierung -> nachfassen.
  var WATCHDOG_AT = [1000, 3000, 8000, 15000];

  var DEBUG = false;
  try {
    DEBUG = new URLSearchParams(window.location.search).get('stChatDebug') === '1';
  } catch (e) {}

  function api() {
    return window.gleenWidget || null;
  }

  function apiReady() {
    var w = api();
    return !!(w && typeof w.open === 'function');
  }

  function findLauncher() {
    var container = document.getElementById('helix-chat-container');
    if (!container) return null;
    return (
      container.querySelector('[aria-label="Open chat"][role="button"]') ||
      container.querySelector('[aria-label="Open chat"]') ||
      container.querySelector('[role="button"]') ||
      container.querySelector('button')
    );
  }

  function openChat() {
    var tries = 0;
    (function attempt() {
      // 1) Offizielle SDK-API bevorzugen.
      if (apiReady()) {
        window.gleenWidget.open();
        return;
      }
      // 2) Fallback: nativen Launcher anklicken, sobald er im DOM hängt.
      var launcher = findLauncher();
      if (launcher) {
        launcher.click();
        return;
      }
      // 3) Widget noch nicht geladen -> kurz retryen.
      if (++tries <= MAX_TRIES) {
        setTimeout(attempt, INTERVAL);
      }
    })();
  }

  function triggerFrom(el) {
    var link = el.closest && el.closest('a[href]');
    if (!link) return null;
    var href = link.getAttribute('href') || '';
    return href.indexOf(SENTINEL) !== -1 ? link : null;
  }

  // Capture-Phase, damit der Klick vor jeglicher Default-Navigation abgefangen wird.
  document.addEventListener(
    'click',
    function (e) {
      var link = triggerFrom(e.target);
      if (!link) return;
      e.preventDefault();
      e.stopPropagation();
      openChat();
    },
    true
  );

  // --- Aufgabe 2: Icebreaker-Postback -> Botpress ---------------------------

  function onPostback(data) {
    // Nie werfen: eine Exception hier wuerde in Alhenas every()-Kette laufen
    // und im schlimmsten Fall das Widget lahmlegen.
    try {
      if (DEBUG) console.log('[st-open-chat] postback', data);
      if (!data || data.postback_payload !== POSTBACK_PAYLOAD) return false;

      var w = api();
      if (w) {
        try { w.close(); } catch (e) {}
        try { if (typeof w.hideLauncher === 'function') w.hideLauncher(); } catch (e) {}
      }

      var win = null;
      try { win = window.open(POSTBACK_URL, '_blank'); } catch (e) {}
      if (win) {
        try { win.opener = null; } catch (e) {}
      } else {
        // Popup geblockt (Safari/iOS) -> gleicher Tab, damit der User ueberhaupt ankommt.
        window.location.assign(POSTBACK_URL);
      }

      return true; // unterdrueckt Alhenas Default-Handling
    } catch (e) {
      if (DEBUG) console.error('[st-open-chat] postback failed', e);
      return false; // im Zweifel Alhena normal weiterarbeiten lassen
    }
  }

  function isRegistered() {
    var w = api();
    var list = w && w.eventCallbacks && w.eventCallbacks[POSTBACK_EVENT];
    return !!(list && list.indexOf(onPostback) !== -1);
  }

  function register() {
    var w = api();
    if (!w || typeof w.on !== 'function') return false;
    if (isRegistered()) return true;
    try {
      w.on(POSTBACK_EVENT, onPostback);
    } catch (e) {
      return false;
    }
    if (DEBUG) console.log('[st-open-chat] postback handler registriert');
    return true;
  }

  (function waitForApi() {
    var started = new Date().getTime();
    (function attempt() {
      if (register()) {
        WATCHDOG_AT.forEach(function (ms) {
          setTimeout(function () {
            if (!isRegistered()) register();
          }, ms);
        });
        return;
      }
      var elapsed = new Date().getTime() - started;
      if (elapsed >= POLL_GIVE_UP) return;
      setTimeout(attempt, elapsed < POLL_FAST_UNTIL ? POLL_FAST_MS : POLL_SLOW_MS);
    })();
  })();
})();
